'use client';
import { cn } from '@baseball-near-you/ui';
import type { Route } from 'next';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

export interface TabProps {
  label: string;
  path: Route;
}

export function PageTab(props: TabProps & { className?: string }) {
  const pathname = usePathname();
  return (
    <Link href={props.path} prefetch={false}>
      <p
        className={cn(
          'title text-gray-800 transition-colors',
          pathname.includes(props.path) && 'font-bold text-red',
          props.className
        )}
      >
        {props.label.toUpperCase()}
      </p>
    </Link>
  );
}
